import { render, staticRenderFns } from "./uc-menu-item.vue?vue&type=template&id=e7087878&"
import script from "./uc-menu-item.vue?vue&type=script&lang=ts&"
export * from "./uc-menu-item.vue?vue&type=script&lang=ts&"
import style0 from "./uc-menu-item.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports